import "es6-promise/auto";

import Vue from "vue";
import Vuex from "vuex";
import VueI18n from "vue-i18n";

import App from "./App.vue";
import store from "./store";

import { currency } from "./filters/currency";
import {
  date,
  dayName,
  dayNumber,
  dayNumberInterval,
  dayTextInterval
} from "./filters/dates";

import i18n from "./lib/i18n";

Vue.filter("currency", currency);
Vue.filter("date", date);
Vue.filter("dayName", dayName);
Vue.filter("dayNumber", dayNumber);
Vue.filter("dayNumberInterval", dayNumberInterval);
Vue.filter("dayTextInterval", dayTextInterval);

Vue.use(VueI18n);
Vue.use(Vuex);

document.addEventListener("DOMContentLoaded", () => {
  const element = document.getElementById("app-event-list");

  /* eslint no-new: 0 */

  if (element != null) {
    new Vue({
      el: "#app-event-list",
      i18n,
      store,
      components: { App },
      render: h => h(App)
    });
  }
});
